import { connect } from "react-redux";
import { form } from "MODULES/shared/components/Forms";
import withSalesOrder from "MODULES/SalesOrders/decorators/withSalesOrder";
import { validate } from "MODULES/SalesOrders/components/shared/FormSections/CustomerSection";
import * as actions from "MODULES/SalesOrders/actions";
import Form from "./Form";

export default withSalesOrder(
  connect(undefined, {
    onSubmit: actions.update
  })(
    form({
      form: "salesOrderDetails",
      validate
    })(Form)
  )
);



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Panel/Details/EditDetails.js